<template>
  <div class="taskInfo">
    <headerPage></headerPage>
    <div class="taskInfo-content">
        <div class="taskInfo-name">
            <div class="taskInfo-desc">
                <div class="taskInfo-title">{{task.name}}
                    <el-button size="mini" v-if="flag" type="warning" @click="removeFavor" icon="el-icon-star-off" circle></el-button>
                    <el-button size="mini" v-if="!flag" type="success" @click="addFavor" icon="el-icon-star-on" circle></el-button>
                </div>
                <div class="taskInfo-title1">
                    <el-tooltip class="item" effect="dark" :content="task.taskDescribe" placement="bottom">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                    {{task.taskDescribe}}
                </div>
            </div> 
            <div class="taskInfo-list">
                <div class="taskInfo-image">
                    <div class="taskInfo-fengmian" v-if="task.image">
                        <img style="width:100%;height:100%" :src="$store.state.HOST + task.image" @error="onImgError">
                    </div>
                    <div class="taskInfo-fengmian-placeholder" v-else>
                        <i class="el-icon-cpu placeholder-icon"></i>
                        <div class="placeholder-name">{{task.classification || '编程课程'}}</div>
                    </div>
                    <div class="taskInfo-btns">
                        <div @click="toQuestion(task.id)" class="taskInfo-icon-btn">
                            <i class="el-icon-question"></i>
                            <span>课程答疑</span>
                        </div>
                        <div @click="toTeacher(task.teacherId)" class="taskInfo-icon-btn">
                            <i class="el-icon-link"></i>
                            <span>课程讲师</span>
                        </div>
                        <div @click="toAssign()" class="taskInfo-icon-btn">
                            <i class="el-icon-news"></i>
                            <span>章节作业</span>
                        </div>
                        <div @click="openCodingTools" class="taskInfo-icon-btn">
                            <i class="el-icon-monitor"></i>
                            <span>编程工具</span>
                        </div>
                        <div @click="toLearning" class="taskInfo-icon-btn">
                            <i class="el-icon-data-line"></i>
                            <span>学习进度</span>
                        </div>
                    </div>
                </div>
                <div class="taskInfo-video">
                    <div v-for="(group,gi) in sections" :key="'g'+gi" class="taskInfo-level-group">
                        <div v-if="group.title" class="taskInfo-level-title">{{group.title}}</div>
                        <div @click="changeLesson(item)" class="taskInfo-video-item" v-for="(item,index) in group.items" :key="index">
                            <div :title="item.name" class="taskInfo-video-item1">{{item.name}}</div>
                            <div class="taskInfo-video-item2">
                                <span v-if="item.homework == 1" class="taskInfo-homework-badge" @click.stop="toLessonHomework(item)">作业</span>
                                <i class="el-icon-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                    <!-- 课程暂未发布课时时的空状态提示 -->
                    <div v-if="chapterLoaded && sections.length == 0" class="taskInfo-video-empty">
                        <i class="el-icon-video-camera"></i>
                        <div class="taskInfo-video-empty-text">该课程暂未发布课时</div>
                        <div class="taskInfo-video-empty-tip">请等待老师在课程章节中添加课时内容</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 班级同学 -->
    <div class="taskInfo-classmates">
        <div class="taskInfo-classmates-title">
            <div class="section-title">班级同学</div>
        </div>
        <div v-if="classStudents.length > 0" class="taskInfo-classmates-list">
            <div class="classmate-item" v-for="(item,index) in classStudents" :key="index">
                <img class="classmate-avatar" :src="avatarSrc(item.avatar)" @error="onAvatarError">
                <div class="classmate-name">{{item.userName}}</div>
            </div>
        </div>
        <div v-else class="taskInfo-classmates-empty">
            <i class="el-icon-user empty-icon"></i>
            <div class="empty-text">你还未加入班级，暂无同学信息</div>
        </div>
    </div>
    
    <!-- 课程讲师介绍弹窗（不再跳转页面） -->
    <el-dialog title="课程讲师" :visible.sync="teacherVisible" width="420px">
        <div v-if="teacher.id" class="teacher-card">
            <img class="teacher-avatar" :src="avatarSrc(teacher.avatar)" @error="onAvatarError">
            <div class="teacher-name">{{teacher.name}}</div>
            <div class="teacher-desc">{{teacher.remark || '该老师暂未填写介绍'}}</div>
        </div>
        <div slot="footer">
            <el-button size="mini" @click="teacherVisible = false">关 闭</el-button>
        </div>
    </el-dialog>

    <!-- 嵌入式编程工具（优先由课程分类决定，其次由班级课程类型决定） -->
    <coding-tool
      :visible.sync="codingDialogVisible"
      :course-type="codingType"
      :task-id="taskId"
      @submit="onCodingSubmit"></coding-tool>
    <bottomPage></bottomPage>
  </div>
</template>

<script>
  import {saveApeTaskFavor,removeApeTaskFavor,getApeTaskFavorById,saveApeChapterVideo,getApeTaskById,getTaskStudent,getApeChapterByTaskId,getMyStudentClass,saveCodingSubmission,getCourseLevelByTaskId,getMyClassStudents,getUserById} from "../../api/api"
  import {mixin} from "../../minix"
  import headerPage from "../../components/header/header"
  import bottomPage from "../../components/bottom/bottom"
  import codingTool from "../../components/coding/codingTool"
  export default {
  mixins: [mixin],
    data() {
      return{
        user: {},
        taskId: "",
        state: 2,
        task: {},
        chapter: [],
        levels: [],
        selectChapter: "",
        selectSrc: "",
        select: false,
        favor: {},
        flag: false,
        codingDialogVisible: false,
        codingType: "",
        classStudents: [],
        teacherVisible: false,
        teacher: {},
        chapterLoaded: false
      }
    },
    components: {
      headerPage,
      bottomPage,
      codingTool
    },
    computed: {
      sections() {
        var sections = []
        var that = this
        var lessons = this.chapter.filter(function(c){ return c.chapterType == 1 })
        var groups = this.chapter.filter(function(c){ return c.chapterType == 0 })
        // 章节分组及其下挂课时
        groups.forEach(function(g){
          var items = lessons.filter(function(l){ return l.parentId == g.id })
          items.sort(function(a,b){ return (a.sortOrder||0)-(b.sortOrder||0) })
          if (items.length > 0) sections.push({ title: g.name, items: items })
        })
        // 历史未分组课时按等级归组
        var ungrouped = lessons.filter(function(l){ return !l.parentId })
        if (this.levels.length > 0) {
          this.levels.forEach(function(level){
            var items = ungrouped.filter(function(l){ return l.levelId == level.id })
            if (items.length > 0) sections.push({ title: level.name, items: items })
          })
          var rest = ungrouped.filter(function(l){ return !l.levelId })
          if (rest.length > 0) sections.push({ title: '其他课时', items: rest })
        } else {
          if (ungrouped.length > 0) sections.push({ title: '', items: ungrouped })
        }
        return sections
      }
    },
    methods: {
        removeFavor() {
            removeApeTaskFavor({ids:this.favor.id}).then(res => {
                if (res.code == 1000) {
                    this.$message({
                        type: 'success',
                        message: '取消收藏成功'
                    });
                    this.getApeTaskFavorById()
                }
            })
        },
        addFavor() {
            var param = {
                taskId: this.taskId,
                userId: this.user.id
            }
            saveApeTaskFavor(param).then(res => {
                if (res.code == 1000) {
                    this.$message({
                        type: 'success',
                        message: '收藏成功'
                    });
                    this.getApeTaskFavorById()
                }
            })
        },
        getApeTaskFavorById() {
            getApeTaskFavorById({taskId: this.taskId,userId:this.user.id}).then(res => {
                if (res.code == 1000) {
                    this.favor = res.data
                    this.flag = true
                } else {
                    this.favor = {}
                    this.flag = false
                }
            })
        },
        toQuestion(id) {
            if (this.state != 0) {
                this.$message({
                    type: 'warning',
                    message: '报名课程通过后才能进行答疑'
                });
                return
            }
            this.$router.push("/question?id=" + id)
        },
        toTeacher(id) {
            // 不再跳转页面，改为弹窗展示讲师信息与介绍，可关闭
            if (!id) return
            getUserById({id: id}).then(res => {
                if (res.code == 1000 && res.data) {
                    this.teacher = res.data
                    this.teacherVisible = true
                }
            })
        },
        toLearning() {
            if (this.state != 0) {
                this.$message({
                    type: 'warning',
                    message: '请先报名课程'
                });
                return
            }
            this.$router.push("/rateOfLearning?id="+this.task.id)
        },
        changeLesson(lesson) {
            if (this.state != 0) {
                this.$message({
                    type: 'warning',
                    message: '报名课程通过后才能查看课件'
                });
                return
            }
            this.select = false
            this.selectChapter = lesson
            // 课件统一为 PPT 格式，学生点击查看课件（在线预览，禁止下载）
            // courseware 可能是 OSS 绝对 URL（https://...）或本地相对路径（/file/...）
            if (lesson.courseware) {
                const url = lesson.courseware.startsWith('http')
                    ? lesson.courseware
                    : this.$store.state.HOST + lesson.courseware
                window.open(url, "_blank")
                // 记录学习进度
                saveApeChapterVideo({ chapterId: lesson.id })
            } else {
                this.$message({
                    type: 'warning',
                    message: '该课时暂无课件'
                });
            }
        },
        toAssign() {
            if (this.state != 0) {
                this.$message({
                    type: 'warning',
                    message: '报名课程通过后才能完成作业'
                });
                return
            }
            // 作业由教师按课时安排，直接进入第一个有作业的课时，无需先手动选择章节
            var lessons = this.chapter.filter(function(c){ return c.chapterType == 1 && c.homework == 1 })
            if (lessons.length == 0) {
                this.$message({
                    type: 'warning',
                    message: '该课程暂未安排作业!'
                });
                return
            }
            this.$router.push("/assignInfo?id=" + lessons[0].id)
        },
        toLessonHomework(lesson) {
            if (this.state != 0) {
                this.$message({
                    type: 'warning',
                    message: '报名课程通过后才能完成作业'
                });
                return
            }
            this.$router.push("/assignInfo?id=" + lesson.id)
        },
        // 根据课程分类映射编程工具类型：课程分类优先，避免班级类型与课程不一致（如 C++ 课程挂在 python 班级）
        mapCodingTypeByClassification(classification) {
            if (!classification) return ""
            var c = (classification + "").toLowerCase()
            if (c.indexOf("scratch") >= 0) return "scratch"
            if (c.indexOf("c++") >= 0 || c.indexOf("cpp") >= 0) return "cpp"
            if (c.indexOf("python") >= 0) return "python"
            return ""
        },
        openCodingTools() {
            // 编程工具优先由课程分类决定，无法识别时回退到学生所在班级的课程类型，不允许自主选择
            var type = this.mapCodingTypeByClassification(this.task.classification)
            if (type) {
                this.codingType = type
                this.codingDialogVisible = true
                return
            }
            getMyStudentClass().then(res => {
                if (res.code == 1000 && res.data && res.data.courseType) {
                    this.codingType = res.data.courseType
                    this.codingDialogVisible = true
                } else if (res.code == 1000 && res.data) {
                    // 已加入班级但班级未配置编程工具类型
                    this.$message({
                        type: 'warning',
                        message: '当前班级未配置编程工具，请联系老师配置后再使用'
                    })
                } else {
                    this.$message({
                        type: 'warning',
                        message: '你还未加入班级，请联系老师加入班级后再使用编程工具'
                    })
                }
            })
        },
        onCodingSubmit(payload) {
            var param = {
                taskId: this.taskId,
                chapterId: this.selectChapter ? this.selectChapter.id : null,
                codingType: payload.codingType,
                content: payload.content,
                remark: payload.remark
            }
            saveCodingSubmission(param).then(res => {
                if (res.code == 1000) {
                    this.$message({ type: 'success', message: '编程任务提交成功!' });
                } else {
                    this.$notify.error({ title: '错误', message: res.message });
                }
            })
        },
        loadClassStudents() {
            getMyClassStudents().then(res => {
                if (res.code == 1000) {
                    this.classStudents = res.data
                }
            })
        },
        onImgError(e) {
            e.target.style.display = 'none'
        }
    },
    created() {
     
    },
    mounted() {
      window.scrollTo({
         top: 0,
         behavior: 'smooth'
      });
      this.user = JSON.parse(window.localStorage.getItem("user_info"))
      var that = this
      this.taskId = this.$route.query.id
      getApeTaskById({id:this.taskId}).then(res => {
          if (res.code == 1000) {
            this.task = res.data
          }
      })
      getTaskStudent({id:this.taskId}).then(res => {
          if (res.code == 1000) {
            this.state = res.data
          }
      })
      getApeChapterByTaskId({id: this.taskId}).then(res => {
          if (res.code == 1000) {
            this.chapter = res.data
          }
      }).finally(() => {
          this.chapterLoaded = true
      })
      getCourseLevelByTaskId({id: this.taskId}).then(res => {
          if (res.code == 1000) {
            this.levels = res.data
          }
      })
      this.getApeTaskFavorById()
      this.loadClassStudents()
    }
 }
</script>

<style scoped>
  @import url("../../assets/css/task/taskInfo.css");
  .taskInfo-level-group {
    display: contents;
  }
  .taskInfo-level-title {
    flex-shrink: 0;
    margin: 8px 10px 2px;
    padding: 4px 8px;
    font-size: 13px;
    font-weight: 600;
    color: #2c4dd6;
    border-left: 3px solid #2c4dd6;
    background: #f2f5ff;
    border-radius: 3px;
  }
  /* 封面占位符 */
  .taskInfo-fengmian-placeholder {
    border-radius: 5px;
    overflow: hidden;
    margin-top: 2%;
    width: 95%;
    height: 83%;
    background: linear-gradient(135deg, #EEF0FF 0%, #E0E7FF 50%, #C7CDFF 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .taskInfo-fengmian-placeholder .placeholder-icon {
    font-size: 64px;
    color: var(--primary);
    opacity: 0.5;
    margin-bottom: 12px;
  }
  .taskInfo-fengmian-placeholder .placeholder-name {
    font-size: 16px;
    color: var(--primary);
    opacity: 0.7;
    font-weight: 600;
    letter-spacing: 2px;
  }
  /* 按钮改为图标+文字常驻显示 */
  .taskInfo-btns {
    width: 95%;
    height: auto;
    min-height: 15%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px 0;
  }
  .taskInfo-icon-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 6px 10px;
    border-radius: 8px;
    transition: all .2s ease;
    min-width: 64px;
  }
  .taskInfo-icon-btn:hover {
    background: var(--primary-bg);
  }
  .taskInfo-icon-btn i {
    font-size: 24px;
    color: var(--primary);
    margin-bottom: 2px;
  }
  .taskInfo-icon-btn span {
    font-size: 11px;
    color: var(--text-sub);
    white-space: nowrap;
  }
  /* 班级同学区域 */
  .taskInfo-classmates {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 0 40px;
    background: var(--bg-page);
  }
  .taskInfo-classmates-title {
    width: 75%;
    margin-bottom: 16px;
  }
  .taskInfo-classmates-title .section-title {
    font-size: 20px;
    font-weight: 700;
    color: var(--text-main);
    display: flex;
    align-items: center;
    letter-spacing: 1px;
  }
  .taskInfo-classmates-title .section-title::before {
    content: '';
    width: 6px;
    height: 20px;
    margin-right: 10px;
    border-radius: 3px;
    background: var(--grad-primary);
  }
  .taskInfo-classmates-list {
    width: 75%;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }
  .classmate-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px 16px;
    background: #FFFFFF;
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-soft);
    transition: all .2s ease;
    min-width: 80px;
  }
  .classmate-item:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(91, 108, 255, 0.15);
  }
  .classmate-avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 2px solid #C7CDFF;
    object-fit: cover;
    margin-bottom: 6px;
  }
  .classmate-name {
    font-size: 12px;
    color: var(--text-main);
    text-align: center;
    max-width: 72px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .taskInfo-classmates-empty {
    width: 75%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
    background: #FFFFFF;
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-soft);
  }
  .taskInfo-classmates-empty .empty-icon {
    font-size: 48px;
    color: #C7CDFF;
    margin-bottom: 10px;
  }
  .taskInfo-classmates-empty .empty-text {
    font-size: 14px;
    color: var(--text-sub);
  }
  /* 课时行内作业角标，点击进入该课时的作业 */
  .taskInfo-homework-badge {
    display: inline-block;
    margin-right: 6px;
    padding: 2px 8px;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    background: var(--grad-primary);
    border-radius: 9px;
    cursor: pointer;
  }
  .taskInfo-homework-badge:hover {
    opacity: 0.85;
  }
  /* 课时空状态提示 */
  .taskInfo-video-empty {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 10px;
    color: var(--text-sub);
  }
  .taskInfo-video-empty i {
    font-size: 40px;
    color: #C7CDFF;
    margin-bottom: 10px;
  }
  .taskInfo-video-empty-text {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-main);
    margin-bottom: 4px;
  }
  .taskInfo-video-empty-tip {
    font-size: 12px;
  }
  /* 讲师介绍弹窗 */
  .teacher-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 0;
  }
  .teacher-avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 2px solid #C7CDFF;
    object-fit: cover;
    margin-bottom: 10px;
  }
  .teacher-name {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-main);
    margin-bottom: 8px;
  }
  .teacher-desc {
    font-size: 13px;
    color: var(--text-sub);
    text-align: center;
    line-height: 1.8;
    white-space: pre-wrap;
    max-height: 200px;
    overflow: auto;
  }
</style>
